import { render, staticRenderFns } from "./RemoveCollaborator.vue?vue&type=template&id=ca0e6e28&scoped=true"
import script from "./RemoveCollaborator.vue?vue&type=script&lang=js"
export * from "./RemoveCollaborator.vue?vue&type=script&lang=js"
import style0 from "./RemoveCollaborator.vue?vue&type=style&index=0&id=ca0e6e28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0e6e28",
  null
  
)

export default component.exports